import { IconButton } from "@bonusx-global/bx-design-system";
import { SearchOutlined } from "@bonusx-global/bx-icons";
import { useCallback } from "react";
import { useSearchModule } from "../../../../../hooks/useSearchModule";

function HeaderV2SearchIcon(): JSX.Element {
  const { reset } = useSearchModule();

  const onClickIconCallback = useCallback(
    function onClickIcon() {
      reset({ visible: true });
    },
    [reset]
  );

  return (
    <IconButton color="primary" onClick={onClickIconCallback}>
      <SearchOutlined />
    </IconButton>
  );
}

export default HeaderV2SearchIcon;
